import script from "./BulkOperationList.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkOperationList.vue?vue&type=script&setup=true&lang=js"

import "./BulkOperationList.vue?vue&type=style&index=0&id=34a066c0&scoped=true&lang=css"

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a066c0"]])

export default __exports__